var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.90323C11.3306 1.90323 14.0968 4.64113 14.0968 8C14.0968 11.3871 11.3589 14.0968 8 14.0968C4.6129 14.0968 1.90323 11.3871 1.90323 8C1.90323 4.64113 4.6129 1.90323 8 1.90323ZM8 1C4.13306 1 1 4.16129 1 8C1 11.8669 4.13306 15 8 15C11.8387 15 15 11.8669 15 8C15 4.16129 11.8387 1 8 1ZM6.98387 10.7097C6.78629 10.7097 6.64516 10.879 6.64516 11.0484V11.2742C6.64516 11.4718 6.78629 11.6129 6.98387 11.6129H9.01613C9.18548 11.6129 9.35484 11.4718 9.35484 11.2742V11.0484C9.35484 10.879 9.18548 10.7097 9.01613 10.7097H8.67742V6.75806C8.67742 6.58871 8.50806 6.41935 8.33871 6.41935H6.98387C6.78629 6.41935 6.64516 6.58871 6.64516 6.75806V6.98387C6.64516 7.18145 6.78629 7.32258 6.98387 7.32258H7.32258V10.7097H6.98387ZM8 3.93548C7.49194 3.93548 7.09677 4.35887 7.09677 4.83871C7.09677 5.34677 7.49194 5.74194 8 5.74194C8.47984 5.74194 8.90323 5.34677 8.90323 4.83871C8.90323 4.35887 8.47984 3.93548 8 3.93548Z",
    fill: "#FF671E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon2);
export default __webpack_public_path__ + "static/media/info-icon-2.4962110311695ec9d5161f97e65648d7.svg";
export { ForwardRef as ReactComponent };